import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-8" }

import { onMounted, reactive } from "vue";
import DashboardTable, { RowOption } from "./DashboardTable.vue";
import { useDataStore } from "@/store/data-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscribedUsers',
  setup(__props) {


const dataStore = useDataStore();

const actions: RowOption[] = [{
	actionName: "Promote to user",
	async action(userData){
		console.log("Promote to user", userData);
		var email = userData[2];
		await dataStore.promoteSubscribedUser(email);
		refreshSubscribedUsers();
	}
}]

const data = reactive({
	columns: ["Firstname", "Lastname", "Email"],
	currentPage: 0,
	pageCount: 1,
	itemsPerPage: 20,
	users: [] as any[]
})

async function onPageChanged(page: number){
	console.log("Page changed:", page);
	data.currentPage = page;
	refreshSubscribedUsers();
}

async function refreshSubscribedUsers(){
	var usersData = await dataStore.getSubscribedUsers(data.currentPage * data.itemsPerPage, data.itemsPerPage);
	data.users = usersData.data.map((u:any)=>[u.name, u.lastname, u.email]);
	data.pageCount = Math.ceil(usersData.totalCount / data.itemsPerPage);
}

onMounted(()=>{
	refreshSubscribedUsers();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DashboardTable, {
        columns: data.columns,
        data: data.users,
        "row-actions": actions,
        onOnPageChanged: onPageChanged
      }, null, 8, ["columns", "data"])
    ])
  ]))
}
}

})